import React from 'react';
import PropTypes from 'prop-types';
import { BRAND_LIBRARY_LIGHT_TEXT_COLOR, BRAND_LIBRARY_HEADLINE_TEXT } from 'common/constants/brandLibrary';

import Headline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';

export default function EventTitleHeadline(props) {
    const {
        event: { title },
    } = useTouchpointData();
    const propsWithEventTitleOverride = {
        ...props,
        meta: {
            ...props.meta,
            content: title,
        },
    };
    return <Headline {...propsWithEventTitleOverride} contentEditable={false} as="h1" />;
}

EventTitleHeadline.splash = {
    ...Headline.splash,
    defaultProps: {
        ...Headline.splash.defaultProps,
        styles: {
            ...Headline.splash.defaultProps.styles,
            fontSize: 54,
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            fontFamily: BRAND_LIBRARY_HEADLINE_TEXT,
        },
    },
};

EventTitleHeadline.propTypes = {
    meta: PropTypes.shape({
        content: PropTypes.string,
    }).isRequired,
};
